import styled from "styled-components";
import { StyledMainContainer as DefaultStyledMainContainer } from "../styles";

export const StyledMainContainer = styled(DefaultStyledMainContainer)`
  // This step should be 36 px higher since it doesn't contain the ticker
  height: 308px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    margin-top: 36px;
    margin-bottom: 8px;
  }
`;

export const Title = styled.div`
  font-size: 40px;
  font-weight: 700;
  letter-spacing: -1px;
  margin-top: 52px;
  margin-bottom: 16px;
`;

export const Description = styled.div`
  color: #2a2a3d;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.5px;

  span {
    font-weight: 500;
  }
`;
